import { Observable } from 'rxjs';
import { LessonDTO, WorksheetItemType, StreamEventDTO, ModifyKnowledgeFormDTO, CreateSlidesParamsDTO, GenerationStatus, CreateLessonFormDTO, GenerateScenarioFormDTO } from '@superlekcja/shared';

export interface AppError {
  message: string;
  details?: any; // For additional error information
}

/**
 * Odmowa z backendu na sciezce modyfikacji (HTTP 400 z polem `code`). Leci PRZED otwarciem
 * strumienia i przed pobraniem kredytu, wiec nie jest awaria generacji: nie ma czego cofac
 * i nie wolno pokazywac jej jako bledu lekcji. UI keyuje komunikat po `code` (+ `reason`).
 */
export class InstructionRejectedError extends Error {
  constructor(
    public readonly code: string,
    public readonly reason?: string,
    message?: string
  ) {
    super(message ?? code);
    this.name = 'InstructionRejectedError';
  }
}

export interface ILessonClient {
  readonly lesson$: Observable<LessonDTO | null>;
  readonly events$: Observable<StreamEventDTO>;
  readonly autogenComplete$: Observable<{ topic: string }>;

  createLesson(params: CreateLessonFormDTO): Promise<void>;
  modifyScenario(params: GenerateScenarioFormDTO): Promise<void>;
  getLesson(id: string): Promise<void>;
  createOrModifyKnowledge(params: ModifyKnowledgeFormDTO): Promise<void>;
  createOrModifySlides(params: CreateSlidesParamsDTO): Promise<void>;
  updateLesson(lessonUpdate: Partial<LessonDTO['params']>): Promise<void>;
  
  generateWorksheetItem(materialTemplateIndex: string|null, itemToRegenerate:string|null): Promise<void>;

  removeWorksheetItem(itemId: string): Promise<void>;

  version(item: 'scenario' | 'knowledge' | 'slides' | 'worksheet' | 'image', step: -1 | 1, onVersion: (lesson:LessonDTO)=>void): Promise<void>;
  copy(): Promise<{id:string, slug:string}>;
  /** Dokupuje kolejna pule elementow do biezacej lekcji (model cenowy 2.0). */
  buyElements(): Promise<void>;
  clearState(): void;
  generateImage(): Promise<void>;
  delete(): Promise<void>;
} 